import { render, staticRenderFns } from "./DeliverEdit3.vue?vue&type=template&id=58c2b678&scoped=true"
import script from "./DeliverEdit3.vue?vue&type=script&lang=js"
export * from "./DeliverEdit3.vue?vue&type=script&lang=js"
import style0 from "./DeliverEdit3.vue?vue&type=style&index=0&id=58c2b678&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c2b678",
  null
  
)

export default component.exports